// ============================================================================
// UKRAINIAN TRANSLATIONS - CHAPTER 5: РАННЯ ЦЕРКВА
// ============================================================================
// Рівні 53-65 (13 рівнів, 39 питань)

export const chapter5Translations = {
  name: "Рання Церква",
  description: "Ви приймете силу...",
  
  spiritualWisdom: {
    principle: "Святий Дух дає силу й мужність для свідчення",
    scripture: "Але ви приймете силу, коли зійде на вас Дух Святий, і будете Мені свідками (Дії 1:8)",
    application: "Церква народжується у вогні Духа й росте через сміливе свідчення"
  },
  
  levels: {
    53: {
      name: "Вознесіння",
      challenge: "Будете Мені свідками... аж до краю землі...",
      easy: {
        question: "Через скільки днів після воскресіння Ісус вознісся на небо?",
        options: ["30 днів", "40 днів", "50 днів", "60 днів"],
        hint: "Біблійне число приготування",
        funFact: "☁️ 40 днів інтенсивного навчання перед світовою місією!"
      },
      medium: {
        question: "Яку обітницю дав Ісус перед вознесінням?",
        options: [
          "Що повернеться негайно",
          "Що пошле Святого Духа з силою",
          "Що побудує церкву",
          "Що покарає злих"
        ],
        hint: "Сила згори",
        funFact: "⚡ Обітниця Святого Духа - перетворення налякаиих учнів!"
      },
      hard: {
        question: "Що символізує Вознесіння в нашому духовному житті?",
        options: [
          "Кінець присутності Ісуса",
          "Ісус царює на небесах і заступається за нас",
          "Остаточне прощання",
          "Символічний міф"
        ],
        hint: "Йдеться про живу присутність у славі",
        funFact: "👑 Ісус сидить праворуч Бога, царює й заступається за нас!"
      }
    },
    
    54: {
      name: "П'ятдесятниця",
      challenge: "Сповнилися всі Духа Святого і почали говорити...",
      easy: {
        question: "Через скільки днів після Вознесіння сталася П'ятдесятниця?",
        options: ["7 днів", "10 днів", "14 днів", "20 днів"],
        hint: "Близько десяти днів",
        funFact: "🔟 10 днів палкої молитви готують злиття Духа!"
      },
      medium: {
        question: "У якій формі з'явився Святий Дух?",
        options: [
          "Як могутній вітер",
          "Як язики, що розділялися, наче вогненні",
          "Як голуб",
          "Як світло"
        ],
        hint: "Полум'я, що спочивало на кожному учневі",
        funFact: "🔥 Вогненні язики: Дух дає мужність і дар мов!"
      },
      hard: {
        question: "Що представляє П'ятдесятниця для вселенської Церкви?",
        options: [
          "Ізольована історична подія",
          "Офіційне народження місіонерської Церкви",
          "Диво цікавості",
          "Початок свята"
        ],
        hint: "Йдеться про свідоцтво про народження Церкви",
        funFact: "🎂 П'ятдесятниця = день народження Церкви, початок світової місії!"
      }
    },

    55: {
      name: "Перша Проповідь Петра",
      challenge: "Що нам робити, браття? Покайтеся...",
      easy: {
        question: "Скільки людей хрестилося після проповіді Петра?",
        options: ["1000", "2000", "3000", "5000"],
        hint: "Три тисячі душ",
        funFact: "🌊 3000 хрещень за один день - надзвичайне духовне пробудження!"
      },
      medium: {
        question: "У чому Петро звинуватив натовп?",
        options: [
          "У невігластві",
          "У розп'ятті Ісуса, Месії",
          "У браку віри",
          "У лицемірстві"
        ],
        hint: "Найвищий гріх проти Сина Божого",
        funFact: "⚔️ Петро, що зрікся Ісуса, тепер проголошує Його божественність!"
      },
      hard: {
        question: "Як перетворення Петра показує дію Святого Духа?",
        options: [
          "Він став більш освіченим",
          "З боязкого й нестійкого став сміливим і твердим у вірі",
          "Він здобув владу",
          "Він змінив характер"
        ],
        hint: "Йдеться про освячення Духом",
        funFact: "🗿 'Хитка тростина' стає 'твердою скелею' - сила перетворення!"
      }
    },

    56: {
      name: "Перша Громада",
      challenge: "Вони перебували постійно в науці апостолів і в спілкуванні...",
      easy: {
        question: "Як перші християни ділилися майном?",
        options: [
          "Кожен зберігав своє",
          "Ділилися всім",
          "Тільки багаті давали",
          "За юридичним обов'язком"
        ],
        hint: "Добровільний поділ майна",
        funFact: "🤝 Братня любов така інтенсивна, що добровільно ділилися всім!"
      },
      medium: {
        question: "На що перші християни витрачали свій час?",
        options: [
          "Тільки на бізнес",
          "Навчання, спілкування, переламування хліба, молитва",
          "Тільки на роботу",
          "Дозвілля"
        ],
        hint: "Чотири стовпи громадського життя",
        funFact: "⛪ Навчання, спілкування, Євхаристія, молитва - основи Церкви!"
      },
      hard: {
        question: "Чому ця перша громада була такою привабливою?",
        options: [
          "Вони були багатими",
          "Справжня любов і радість випромінювалися від їхньої єдності",
          "Вони обіцяли чудеса",
          "Вони критикували інших"
        ],
        hint: "Йдеться про живе свідчення любові",
        funFact: "✨ 'Дивіться, як вони люблять один одного!' - свідчення переконливіше за слова!"
      }
    },

    57: {
      name: "Зцілення Кульгавого",
      challenge: "Срібла й золота немає в мене, а що маю, те даю тобі...",
      easy: {
        question: "Скільки часу ця людина була кульгавою?",
        options: [
          "20 років",
          "30 років", 
          "Від народження",
          "10 років"
        ],
        hint: "Інвалідність від народження",
        funFact: "🚶 40 років інвалідності миттєво зцілені в ім'я Ісуса!"
      },
      medium: {
        question: "В ім'я кого Петро зцілив кульгавого?",
        options: [
          "В ім'я Бога",
          "В ім'я Ісуса Христа Назорея",
          "В своє ім'я",
          "В ім'я Авраама"
        ],
        hint: "Ім'я вище всякого імені",
        funFact: "✊ Ім'я Ісуса продовжує творити чудеса через апостолів!"
      },
      hard: {
        question: "Що символізує це зцілення для Євангелія?",
        options: [
          "Просте медичне чудо",
          "Повне спасіння, яке приносить Ісус: духовне й фізичне",
          "Сила апостолів",
          "Благодійність для бідних"
        ],
        hint: "Йдеться про повне спасіння людини",
        funFact: "🩺 Ісус зцілює душу й тіло - повне спасіння людини!"
      }
    },

    58: {
      name: "Початок Переслідувань",
      challenge: "Треба коритися більше Богові, ніж людям...",
      easy: {
        question: "Хто заарештував Петра й Іоана після зцілення кульгавого?",
        options: [
          "Римляни",
          "Садукеї та священики",
          "Народ",
          "Пилат"
        ],
        hint: "Юдейська релігійна влада",
        funFact: "⛓️ Перші релігійні переслідування - Євангелія тривожить істеблішмент!"
      },
      medium: {
        question: "Що влада заборонила апостолам?",
        options: [
          "Залишати Єрусалим",
          "Більше не вчити в ім'я Ісуса",
          "Більше не творити чудес",
          "Більше не молитися"
        ],
        hint: "Заборона на проповідь",
        funFact: "🚫 Спроба заглушити істину - неможливо зупинити Євангелію!"
      },
      hard: {
        question: "Як апостоли відреагували на заборону?",
        options: [
          "Злякалися й підкорилися",
          "Заявили, що треба коритися більше Богові, ніж людям",
          "Вели переговори",
          "Втекли"
        ],
        hint: "Йдеться про вірність вище людського закону",
        funFact: "⚖️ Громадянська непокора заради послуху Богові - мужність переконань!"
      }
    },

    59: {
      name: "Ананія та Сапфіра",
      challenge: "Ти збрехав не людям, а Богові...",
      easy: {
        question: "Яку брехню сказали Ананія та Сапфіра?",
        options: [
          "Вони нічого не продавали",
          "Приховали частину, кажучи, що віддають все",
          "Вони були бідними",
          "Вони не були одружені"
        ],
        hint: "Брехня про пожертвувану суму",
        funFact: "💰 Приховати частину було допустимо, збрехати про пожертву - ні!"
      },
      medium: {
        question: "Що з ними сталося після брехні?",
        options: [
          "Були прощені",
          "Померли миттєво",
          "Були вигнані",
          "Покаялися"
        ],
        hint: "Негайне суворе покарання",
        funFact: "⚱️ Суворий суд для збереження чистоти новонародженої Церкви!"
      },
      hard: {
        question: "Чому таке суворе покарання на початку Церкви?",
        options: [
          "Бог був жорстоким",
          "Щоб встановити святість, потрібну від громади",
          "Щоб залякати",
          "Випадковість"
        ],
        hint: "Йдеться про збереження духовної цілісності",
        funFact: "🔥 Високі стандарти на початку для встановлення культури святості!"
      }
    },

    60: {
      name: "Сім Дияконів",
      challenge: "Виберіть із-поміж себе сім чоловіків випробуваних...",
      easy: {
        question: "Скільки дияконів було обрано?",
        options: ["5", "6", "7", "12"],
        hint: "Число досконалості",
        funFact: "7️⃣ Сім дияконів для служіння - божественна організація Церкви!"
      },
      medium: {
        question: "Яка була їхня головна роль?",
        options: [
          "Проповідувати Євангелію",
          "Служити за столами й допомагати вдовам",
          "Хрестити новонавернених",
          "Керувати фінансами"
        ],
        hint: "Соціальне й матеріальне служіння",
        funFact: "🍽️ Служіння за столами = перша християнська благодійна організація!"
      },
      hard: {
        question: "Що ця організація відкриває про христанське бачення служіння?",
        options: [
          "Матеріальна робота нижча",
          "Духовне й матеріальне служіння однаково священні",
          "Потрібно відділяти священне від світського",
          "Тільки священики справді служать"
        ],
        hint: "Йдеться про священність будь-якого служіння любові",
        funFact: "✨ Служіння за столами з тією ж гідністю, що й проповідь - будь-яке служіння священне!"
      }
    },

    61: {
      name: "Стефан, Перший Мученик",
      challenge: "Господи! не приписуй їм цього гріха! Сказавши це, спочив...",
      easy: {
        question: "Якою була роль Стефана в Церкві?",
        options: ["Апостол", "Диякон", "Священик", "Пророк"],
        hint: "Один із семи обраних для служіння",
        funFact: "✨ Стефан: диякон стає могутнім євангелістом і першим мучеником!"
      },
      medium: {
        question: "У чому Стефан звинуватив юдейських лідерів?",
        options: [
          "У корупції",
          "У постійному противленні Святому Духові",
          "У лицемірстві",
          "У жадібності"
        ],
        hint: "Історичний опір Богові",
        funFact: "📜 Стефан резюмує історію: постійний бунт проти Бога!"
      },
      hard: {
        question: "Як Стефан помер і що відкриває його позиція?",
        options: [
          "У гніві на катів",
          "Прощаючи, як Ісус на хресті",
          "У відчаї",
          "Проклинаючи ворогів"
        ],
        hint: "Йдеться про досконале наслідування Христа",
        funFact: "💝 Прощення катам: Стефан досконало відтворює позицію Ісуса!"
      }
    },

    62: {
      name: "Пилип і Ефіопський Євнух",
      challenge: "Як можу розуміти, коли ніхто мені не поясне?",
      easy: {
        question: "Що євнух читав у колісниці?",
        options: [
          "Псалми",
          "Пророка Ісаю",
          "Буття",
          "Приповісті"
        ],
        hint: "Пророк про страждання Месії",
        funFact: "📖 Ісая 53 - досконале пророцтво про Ісуса, читане щирим шукачем!"
      },
      medium: {
        question: "Як Пилип пояснив уривок з Ісаї?",
        options: [
          "Розповів про давню історію",
          "Благовістив йому Ісуса від цього Писання",
          "Провів урок богослов'я",
          "Критикував тлумачення"
        ],
        hint: "Писання природно веде до Христа",
        funFact: "✝️ Усе Писання сходиться в Ісусі - ключ розуміння!"
      },
      hard: {
        question: "Що символізує навернення ефіопського євнуха?",
        options: [
          "Ізольоване навернення",
          "Універсальність Євангелії для всіх рас і становищ",
          "Перевага певної національності",
          "Особливий випадок"
        ],
        hint: "Йдеться про відкритість для народів",
        funFact: "🌍 Ефіоп, євнух, міністр: Євангелія руйнує всі бар'єри!"
      }
    },

    63: {
      name: "Навернення Савла з Тарсу",
      challenge: "Савле, Савле! чого ти Мене гониш?",
      easy: {
        question: "Що Савл робив до навернення?",
        options: [
          "Проповідував Євангелію",
          "Переслідував християн",
          "Був нейтральним",
          "Тільки вчився"
        ],
        hint: "Лютий ворог учнів",
        funFact: "⚔️ Савл дихав погрозами й убивством на учнів Ісуса!"
      },
      medium: {
        question: "На якій дорозі Ісус з'явився Савлові?",
        options: [
          "Дорога до Єрусалиму",
          "Дорога до Дамаску",
          "Дорога до Гази",
          "Дорога до Антіохії"
        ],
        hint: "Місто в Сирії",
        funFact: "🛤️ Дорога до Дамаску = найвідоміше місце перетворення в історії!"
      },
      hard: {
        question: "Як це навернення демонструє благодать Божу?",
        options: [
          "Бог навертає тільки добрих людей",
          "Благодать може перетворити найгіршого ворога на найбільшого апостола",
          "Навернення було заслужене",
          "Савл уже був близький до Бога"
        ],
        hint: "Йдеться про перетворюючу силу благодаті",
        funFact: "⚡ Від найбільшого переслідувача до найбільшого місіонера - чудо благодаті!"
      }
    },

    64: {
      name: "Петро та Корнилій",
      challenge: "Справді пізнаю, що Бог неупереджений...",
      easy: {
        question: "Якою була професія Корнилія?",
        options: [
          "Торговець",
          "Римський сотник",
          "Священик",
          "Книжник"
        ],
        hint: "Офіцер римської армії",
        funFact: "🎖️ Перший офіційно навернений язичник - відкриття для неіудеїв!"
      },
      medium: {
        question: "Яке видіння мав Петро перед зустріччю з Корнилієм?",
        options: [
          "Ангел, що говорить",
          "Полотно з чистими й нечистими тваринами",
          "Ісус, що з'являється",
          "Зруйнований храм"
        ],
        hint: "Видіння про чистоту й нечистоту",
        funFact: "🕊️ Полотно з тваринами: Бог скасовує відмінності в їжі й расах!"
      },
      hard: {
        question: "Який революційний принцип встановило це навернення?",
        options: [
          "Римляни переважають",
          "Бог неупереджений - загальне спасіння",
          "Потрібно відмовитися від традицій",
          "Обрізання марне"
        ],
        hint: "Йдеться про загальність спасіння",
        funFact: "🌍 Духовна революція: Євангелія для всіх народів без винятку!"
      }
    },

    65: {
      name: "Церква в Антіохії",
      challenge: "В Антіохії учні вперше стали називатися християнами...",
      easy: {
        question: "Як вперше назвали учнів в Антіохії?",
        options: ["Учні", "Християни", "Віруючі", "Святі"],
        hint: "Ім'я, яке ми маємо й сьогодні",
        funFact: "✝️ 'Християни' = 'малі Христи' - почесне ім'я, дане язичниками!"
      },
      medium: {
        question: "Хто прийшов навчати в Антіохію разом із Варнавою?",
        options: [
          "Петро",
          "Павло (Савл)",
          "Яків",
          "Іоан"
        ],
        hint: "Колишній переслідувач, що став апостолом",
        funFact: "👥 Варнава шукає Павла в Тарсі - початок служіння Павла!"
      },
      hard: {
        question: "Чому Антіохія стала такою важливою в християнській історії?",
        options: [
          "Вона була багатою",
          "Перший місіонерський центр для язичників",
          "Добре розташована",
          "Мала добрих лідерів"
        ],
        hint: "Йдеться про місіонерську експансію",
        funFact: "🚢 Антіохія: порт відправлення всіх місіонерських подорожей Павла до Європи!"
      }
    }
  }
};

export default chapter5Translations;
